module.exports = __webpack_public_path__ + "media/images/search_icon_white-48318c976cca32769a5b356af2451d17.svg";